import { render, staticRenderFns } from "./HighlightsSnsButtonParts.vue?vue&type=template&id=6deab755&scoped=true"
import script from "./HighlightsSnsButtonParts.vue?vue&type=script&lang=ts"
export * from "./HighlightsSnsButtonParts.vue?vue&type=script&lang=ts"
import style0 from "./HighlightsSnsButtonParts.vue?vue&type=style&index=0&id=6deab755&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6deab755",
  null
  
)

export default component.exports